import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user/user.service';
import { AppearanceService } from '../../services/appearance/appearance.service';
import { ModalController } from '@ionic/angular';
import { JobService } from 'src/app/services/job/job.service';
import { RemedialModel } from 'src/app/models/remedial.model';
import { ObservationModel } from 'src/app/models/observation.model';
import { ClientService } from 'src/app/services/client/client.service';
import { AssetService } from 'src/app/services/asset/asset.service';
import { AssetPresetStlModel } from 'src/app/models/asset_preset_stl.model';
import { Constants } from 'src/app/constants/constants';
import { AssetModel } from 'src/app/models/asset.model';

@Component({
  selector: 'modal-observation',
  templateUrl: './modal-observation.component.html',
  styleUrls: ['./modal-observation.component.scss'],
})
export class ModalObservationComponent implements OnInit {

  selectedAsset: AssetModel = null;
  allRemedials: Array<RemedialModel>;
  title = "Add Observation";
  
  newObservation = null;
  originalObservation = null;
  infoError: boolean = false;

  showCondemnForm: boolean = false;
  condemnPartsTextError: boolean = false;
  condemnPositionTextError: boolean = false;

  createNewObservation: boolean = false;
  isEditing = false;
  isDuplicating = false;
  onJob = null;

  quickPopulate = false;
  headWaterDamage = false;
  headFaultyControlGear = false;
  headOtherDamage = false;
  headOtherDamageDetails = "";
  headRepaired = false;
  headDayBurning = false;
  headObsolete = false;
  headBeyond = false;
  ledRepair = false;
  sonRepair = false;
  soxRepair = false;
  photoCellRepair = false;
  colBeyondLife = false;
  colBaseDamage = false;
  colCorrosion = false;
  colImpact = false;
  columnRecommended = false;
  headDamage = "";
  headDamageTypeStr = "";
  headRepairTypeStr = "";
  colDamage = "";
  colDamageTypeStr = "";
  colActionTypeStr = "";

  showConditionOption = true;
  showPowerOption = true;
  showRecommendOption = true;
  showRepairOption = true;

  constructor(public appearanceService: AppearanceService,
   public userService: UserService, public modalControllerTwo: ModalController, 
   public jobService: JobService, public clientService: ClientService,
   public assetService: AssetService) {

  }


  ngOnInit() 
  {

  }


  ionViewWillEnter()
  {
    this.quickPopulate = false;
    this.allRemedials = this.clientService.getRemedialCodes();
    this.onJob = this.jobService.getCurrentJobUid();

    this.infoError = false;

    if (this.createNewObservation)
    {
      this.newObservation                       = new ObservationModel();
      this.newObservation.chosenRemedials       = new Array<RemedialModel>();
      this.newObservation.presetStlRemedialUids = new Array<any>();
      this.newObservation.observationInfo       = "";
      this.newObservation.conditionCode         = "C3";
      this.newObservation.recommendedOnJobUid   = null;
      this.newObservation.repairedOnJobUid      = null;
      this.newObservation.powerIssue            = null;

      for (var i = 0; i < this.allRemedials.length; i++)
      {
        this.allRemedials[i].quantity = 0;
      }

      this.markAsRecommended(true);
    }
    else
    {
      if (this.isEditing)
      {
        this.title = "Edit Observation";
      }
    
      this.newObservation = new ObservationModel();
      this.newObservation = JSON.parse(JSON.stringify(this.originalObservation));
      this.newObservation.repairedDateTime = null;
      this.newObservation.repairedOnJobUid = null;
      this.newObservation.repairedByUser = null;
      this.newObservation.repairNotes = null;
      
      for (var i = 0; i < this.allRemedials.length; i++)
      {
        this.allRemedials[i].quantity = 0;

        for (var x = 0; x < this.newObservation.chosenRemedials.length; x++)
        {
          if (this.newObservation.chosenRemedials[x].remedialUid == this.allRemedials[i].remedialUid)
          {
            this.allRemedials[i] = this.newObservation.chosenRemedials[x];
          }
        }
      }
    }

    this.isAssetCondemned();
  }


  ionViewDidLeave()
  {
    this.newObservation = null;
    this.originalObservation = null;
  }


  saveNewObservation()
  {
    if (this.newObservation.observationInfo == "")
    {
      this.infoError = true;
      return;
    }

    if (this.isAssetCondemned())
    {
      var condemnErrors = this.checkCondemnForm();

      if (condemnErrors)
      {
        this.appearanceService.presentToast("Please fill out condemned information.", Constants.TOAST_INFO)
        return;
      }
    }
    
    this.assetService.saveLastObservation(this.newObservation);
    
    var returnData = { observation: this.newObservation };
    this.modalControllerTwo.dismiss(returnData, null, 'RemedialModal');
  }


  updateObservation()
  {
    var condemnData = null;

    if (this.isAssetCondemned())
    {
      var condemnErrors = this.checkCondemnForm();

      if (condemnErrors)
      {
        this.appearanceService.presentToast("Please fill out condemned information.", Constants.TOAST_INFO)
        return;
      }

      condemnData = {
        condemnAssetReuseParts: this.newObservation.condemnAssetReuseParts,
        condemnAssetReusePartsText: this.newObservation.condemnAssetReusePartsText,
        condemnAssetIsolated: this.newObservation.condemnAssetIsolated,
        condemnFuseRemoved: this.newObservation.condemnFuseRemoved,
        condemnAssetSufficientLighting: this.newObservation.condemnAssetSufficientLighting,
        condemnAssetDangerousPosition: this.newObservation.condemnAssetDangerousPosition,
        condemnAssetDangerousPositionText: this.newObservation.condemnAssetDangerousPositionText
      }
    }
    
    // Find newly added Remedials.

    var newStls                       = new Array<RemedialModel>();
    var changedStls                   = new Array<RemedialModel>();
    var newStlRemedialPresetUids      = new Array<any>();
    var removedStlRemedialPresetUids  = new Array<any>();

    var foundStl = false;
    
    for (var i = 0; i < this.newObservation.chosenRemedials.length; i++)
    {
      foundStl = false;

      var newStl = this.newObservation.chosenRemedials[i];

      for (var x = 0; x < this.originalObservation.chosenRemedials.length; x++)
      {
        var originalStl = this.originalObservation.chosenRemedials[x];

        if (originalStl.remedialUid == newStl.remedialUid)
        {
          // Exists and quanity changed?
          foundStl = true;

          if (originalStl.quantity != newStl.quantity)
          {
            changedStls.push(newStl);
            break;
          }
        }
      }

      if (!foundStl)
      {
        newStls.push(newStl);
      }
    }


    // check for removed stl codes
    for (var i = 0; i < this.originalObservation.chosenRemedials.length; i++)
    {
      foundStl = false;

      var originalStl = this.originalObservation.chosenRemedials[i];

      for (var x = 0; x < this.newObservation.chosenRemedials.length; x++)
      {
        var newStl = this.newObservation.chosenRemedials[x];

        if (originalStl.remedialUid == newStl.remedialUid)
        {
          foundStl = true;
          break;
        }
      }

      if (!foundStl)
      {
        var copy = { ... originalStl };
        copy.quantity = 0;

        changedStls.push(copy)
      }
    }


    // check for added stl presets
    for (var i = 0; i < this.newObservation.presetStlRemedialUids.length; i++)
    {
      var newPresetUid = this.newObservation.presetStlRemedialUids[i];

      // If it doesn't exist in original then it's new.
      if (!this.originalObservation.presetStlRemedialUids.includes(newPresetUid))
      {
        newStlRemedialPresetUids.push(newPresetUid);   
      }
    }

    // check for removed stl presets
    for (var i = 0; i < this.originalObservation.presetStlRemedialUids.length; i++)
    {
      var originalPresetUid = this.originalObservation.presetStlRemedialUids[i];

      // If original uid doesn't exist in current then it's deleted.
      if (!this.newObservation.presetStlRemedialUids.includes(originalPresetUid))
      {
        removedStlRemedialPresetUids.push(originalPresetUid);   
      }
    }

    var changeMade = false;

    if (this.originalObservation.observationInfo != this.newObservation.observationInfo)
    {
      changeMade = true;
    }

    if (this.originalObservation.conditionCode != this.newObservation.conditionCode)
    {
      changeMade = true;
    }

    if (newStls.length == 0 && changedStls.length == 0 && !changeMade && 
      newStlRemedialPresetUids.length == 0 && removedStlRemedialPresetUids.length == 0)
    {
      this.closeModal();
    }
    else
    {
      var returnData = { 
        updateObservation: true, 
        newStls: newStls, 
        changedStls: changedStls,
        updatedConditionCode: this.newObservation.conditionCode,
        updatedInfo: this.newObservation.observationInfo,
        newStlPresetUids: newStlRemedialPresetUids,
        deletedStlPresetUids: removedStlRemedialPresetUids,
        condemnData: condemnData
      };

      this.modalControllerTwo.dismiss(returnData, null, 'RemedialModal');
    }
  }


  markAsRepaired(choice)
  {
    if (choice)
    {
      this.newObservation.repairedOnJobUid = this.jobService.getCurrentJobUid();
      this.newObservation.repairedByUser = this.userService.getUserEmail();
    }
    else
    {
      this.newObservation.repairedDateTime = null;
      this.newObservation.repairedOnJobUid = null;
      this.newObservation.repairedByUser = null;
      this.newObservation.repairNotes = null;
    }
  }


  markAsRecommended(choice)
  {
    if (choice)
    {
      this.newObservation.recommendedOnJobUid = this.jobService.getCurrentJobUid();

      if (!this.newObservation.recommendedOnJobUid)
      {
        this.newObservation.recommendedOnJobUid = 1;
      }

      this.newObservation.recommendedByUser = this.userService.getUserEmail();
    }
    else
    {
      this.newObservation.recommendedDateTime = null;
      this.newObservation.recommendedOnJobUid = null;
      this.newObservation.recommendedByUser = null;
    }
  }


  closeModal(returnData = null)
  {
    if (this.quickPopulate)
    {
      this.quickPopulate = false;
    }
    else
    {
      this.modalControllerTwo.dismiss(returnData, null, 'RemedialModal');
    }
  }


  increaseStlQuanity(choice)
  {
    if (choice.quantity == 0)
    {
      choice.quantity = 1;
      this.newObservation.chosenRemedials.push(choice);
    }
    else
    {
      for (var i = 0; i < this.newObservation.chosenRemedials.length; i++)
      {
        if (this.newObservation.chosenRemedials[i].remedialUid == choice.remedialUid)
        {
          this.newObservation.chosenRemedials[i].quantity += 1;
          break;
        }
      }
    }
  }


  decreaseStlQuanity(choice)
  {
    var minimum = this.getMinimumStlQuanity(choice.remedialUid);

    if (choice.quantity > 0 && choice.quantity > minimum)
    {
      for (var i = 0; i < this.newObservation.chosenRemedials.length; i++)
      {
        if (this.newObservation.chosenRemedials[i].remedialUid == choice.remedialUid)
        {
          this.newObservation.chosenRemedials[i].quantity--;
          break;
        }
      }
    }
  }


  getMinimumStlQuanity(stlUid)
  {
    var quanity = 0;

    // Loop through presets being used.
    for (var i = 0; i < this.newObservation.presetStlRemedialUids.length; i++)
    {
      var usedPresetUid = this.newObservation.presetStlRemedialUids[i];

      // Find the Stls for the used preset.
      for (var x = 0; x < this.selectedAsset.assetType.allStlPresets.length; x++)
      {
        var foundStlPreset = this.selectedAsset.assetType.allStlPresets[i];

        if (foundStlPreset.uid == usedPresetUid)
        {
          // Find the quanity in this preset...
          for (var y = 0; y < foundStlPreset.defaultStls.length; y++)
          {
            if (foundStlPreset.defaultStls[y].remedialUid == stlUid)
            {
              quanity += foundStlPreset.defaultStls[y].quantity;
              break;
            }
          }
        }
      }
    }

    return quanity;
  }


  isStlPresetInUseIndex(stlPresetUid)
  {
    for (var i = 0; i < this.newObservation.presetStlRemedialUids.length; i++)
    {
      if (this.newObservation.presetStlRemedialUids[i] == stlPresetUid)
      {
        return i;
      }
    }

    return -1;
  }


  toggleStlPreset(stlPreset: AssetPresetStlModel)
  {
    var usedIndex = this.isStlPresetInUseIndex(stlPreset.uid);

    if (usedIndex >= 0)
    {
      this.removeStlPreset(stlPreset);
      this.newObservation.presetStlRemedialUids.splice(usedIndex, 1);

      if (this.newObservation.presetStlRemedialUids.length < 0)
      {
        this.newObservation.presetStlRemedialUids = new Array<any>();
      }
    }
    else
    {
      this.addStlPreset(stlPreset);
      this.newObservation.presetStlRemedialUids.push(stlPreset.uid);
    }

    this.isAssetCondemned();
  }


  setCondemnAssetIsolated(choice)
  {
    this.newObservation.condemnAssetIsolated = choice;

    if(choice == 'No')
    {
      this.newObservation.condemnFuseRemoved = 'No';
    }
  }


  setCondemnAssetReuseParts(choice)
  {
    this.newObservation.condemnAssetReuseParts = choice;

    if(choice == 'No')
    {
      this.newObservation.condemnAssetReusePartsText = null;
    }
  }


  setCondemnAssetDangerousPosition(choice)
  {
    this.newObservation.condemnAssetDangerousPosition = choice;

    if(choice == 'No')
    {
      this.newObservation.condemnAssetDangerousPositionText = null;
    }
  }


  addStlPreset(stlPreset: AssetPresetStlModel)
  {
    if (stlPreset.description)
    {
      this.newObservation.observationInfo = stlPreset.description + " " + this.newObservation.observationInfo;
    }

    for (var i = 0; i < stlPreset.defaultStls.length; i++)
    {
      var defaultStl = stlPreset.defaultStls[i];

      for (var x = 0; x < this.allRemedials.length; x++)
      {
        if (defaultStl.remedialUid == this.allRemedials[x].remedialUid)
        {
          if (this.allRemedials[x].quantity == 0)
          {
            this.newObservation.chosenRemedials.push(this.allRemedials[x]);
          }

          this.allRemedials[x].quantity += defaultStl.quantity;

          break;
        }
      }
    }
  }


  removeStlPreset(stlPreset: AssetPresetStlModel)
  {
    if (stlPreset.description)
    {
      // TODO
      //this.newObservation.observationInfo = stlPreset.description + " " + this.newObservation.observationInfo;
    }

    for (var i = 0; i < stlPreset.defaultStls.length; i++)
    {
      var defaultStl = stlPreset.defaultStls[i];
      var deleteStl = false;

      for (var x = 0; x < this.allRemedials.length; x++)
      {
        if (defaultStl.remedialUid == this.allRemedials[x].remedialUid)
        {
          this.allRemedials[x].quantity -= defaultStl.quantity;

          if (this.allRemedials[x].quantity <= 0)
          {
            this.allRemedials[x].quantity = 0;
            deleteStl = true;
          }

          break;
        }
      }

      if (deleteStl)
      {
        for (var y = 0; y < this.newObservation.chosenRemedials.length; y++)
        {
          if (defaultStl.remedialUid == this.newObservation.chosenRemedials[y].remedialUid)
          {
            this.newObservation.chosenRemedials.splice(y, 1);
            break;
          }
        }
      } 
    }
  }


  checkIfRemedialAlreadyAdded(remedialUid)
  {
    for (var i = 0; i < this.newObservation.chosenRemedials.length; i++)
    {
      if(this.newObservation.chosenRemedials[i].remedialUid == remedialUid)
      {
        return i;
      }
    }

    return -1;
  }


  isAssetCondemned()
  {
    if (this.newObservation.conditionCode == "C1")
    {
      if (this.isStlPresetInUseIndex(6) >= 0 || this.isStlPresetInUseIndex(7) >= 0 || 
        this.isStlPresetInUseIndex(11) >= 0 || this.isStlPresetInUseIndex(15) >= 0)
      {
        this.showCondemnForm = true;

        if (!this.newObservation.condemnAssetReuseParts)
        {
          this.newObservation.condemnAssetReuseParts            = "No";
          this.newObservation.condemnAssetReusePartsText        = null;
          this.newObservation.condemnAssetIsolated              = "No";
          this.newObservation.condemnFuseRemoved                = "No";
          this.newObservation.condemnAssetSufficientLighting    = "No";
          this.newObservation.condemnAssetDangerousPosition     = "No";
          this.newObservation.condemnAssetDangerousPositionText = null;
        }

        return true;
      }
    }

    this.showCondemnForm = false;
    this.newObservation.condemnAssetReuseParts            = null;
    this.newObservation.condemnAssetReusePartsText        = null;
    this.newObservation.condemnAssetIsolated              = null;
    this.newObservation.condemnFuseRemoved                = null;
    this.newObservation.condemnAssetSufficientLighting    = null;
    this.newObservation.condemnAssetDangerousPosition     = null;
    this.newObservation.condemnAssetDangerousPositionText = null;

    return false;
  }


  setConditionCode(code)
  {
    this.newObservation.conditionCode = code;

    this.isAssetCondemned();
  }


  checkCondemnForm()
  {
    var errorFound = false;

    if (this.newObservation.condemnAssetReuseParts == "Yes")
    {
      if (!this.newObservation.condemnAssetReusePartsText)
      {
        this.condemnPartsTextError = true;
        errorFound = true;
      }
    }

    if (this.newObservation.condemnAssetDangerousPosition == "Yes")
    {
      if (!this.newObservation.condemnAssetDangerousPositionText)
      {
        this.condemnPositionTextError = true;
        errorFound = true;
      }
    }

    return errorFound;
  }


  colDamageType(choice)
  {
    switch(choice)
    {
      case 'beyond':
        this.colBeyondLife = !this.colBeyondLife;
        break;

      case 'base':
        this.colBaseDamage = !this.colBaseDamage;
        break;

      case 'corrosion':
        this.colCorrosion = !this.colCorrosion;
        break;

      case 'impact':
        this.colImpact = !this.colImpact;
        break;
    }

    if (this.colBeyondLife || this.colBaseDamage || this.colCorrosion || this.colImpact)
    {
      this.colDamageTypeStr = "Existing column";

      if (this.colBeyondLife && !this.colBaseDamage && !this.colCorrosion && !this.colImpact)
      {
        this.colDamageTypeStr = "Existing column is beyond life.";
      }
      else if (!this.colBeyondLife && this.colBaseDamage && !this.colCorrosion && !this.colImpact)
      {
        this.colDamageTypeStr = "Existing column has damage at the base.";
      }
      else if (!this.colBeyondLife && !this.colBaseDamage && this.colCorrosion && !this.colImpact)
      {
        this.colDamageTypeStr = "Existing column has signs of corrosion.";
      }
      else if (!this.colBeyondLife && !this.colBaseDamage && !this.colCorrosion && this.colImpact)
      {
        this.colDamageTypeStr = "Existing column has suffered an impact.";
      }
      else if (this.colBeyondLife && this.colBaseDamage && this.colCorrosion && this.colImpact)
      {
        this.colDamageTypeStr = "Existing column has suffered an impact, with damage at the base, signs of corrosion and is beyond life.";
      }
      else
      {
        if (this.colImpact)
        {
          this.colDamageTypeStr += " has suffered an impact";

          if (this.colBaseDamage)
          {
            this.colDamageTypeStr += " with damage at the base";

            if (this.colCorrosion)
            {
              if (this.colBeyondLife)
              {
                this.colDamageTypeStr += ", signs of corrosion";
              }
              else
              {
                this.colDamageTypeStr += " and signs of corrosion";
              }
            }
          }
          else
          {
            if (this.colCorrosion)
            {
              this.colDamageTypeStr += " with signs of corrosion";
            }
          }
        }
        else
        {
          if (this.colBaseDamage)
          {
            this.colDamageTypeStr += " has damage at the base";

            if (this.colCorrosion)
            {
              this.colDamageTypeStr += " with signs of corrosion";
            }
          }
          else
          {
            if (this.colCorrosion)
            {
              this.colDamageTypeStr += " has signs of corrosion";
            }
          }
        }

        if (this.colBeyondLife)
        {
          this.colDamageTypeStr += " and is beyond life.";
        }
        else
        {
          this.colDamageTypeStr += ".";
        }
      }
    }
    else
    {
      this.colDamageTypeStr = "";
    }

    this.colDamage = this.colDamageTypeStr + this.colActionTypeStr;
  }


  newColRecommeded()
  {
    this.columnRecommended = !this.columnRecommended;

    this.colActionTypeStr = "";

    if (this.columnRecommended)
    {
      if (this.colDamageTypeStr == "")
      {
        this.colActionTypeStr = "A new column is recommended.";
      }
      else
      {
        this.colActionTypeStr = " A new column is recommended.";
      }
    }
    
    this.colDamage = this.colDamageTypeStr + this.colActionTypeStr;
  }


  headDamageType(choice)
  {
    switch(choice)
    {
      case 'water':
        this.headWaterDamage = !this.headWaterDamage;
        break;

      case 'gear':
        this.headFaultyControlGear = !this.headFaultyControlGear;
        break;

      case 'dayburn':
        this.headDayBurning = !this.headDayBurning;
        break;

      case 'other':
        this.headOtherDamage = !this.headOtherDamage;
        break;

      case 'obsolete':
        this.headObsolete = !this.headObsolete;
        break;

      case 'beyond':
        this.headBeyond = !this.headBeyond;
        break;
    }

    if (this.headWaterDamage || this.headFaultyControlGear || this.headDayBurning || this.headOtherDamage || this.headObsolete || this.headBeyond)
    {
      this.headDamageTypeStr = "Existing head";

        if (this.headOtherDamage && !this.headWaterDamage && !this.headFaultyControlGear && !this.headDayBurning && !this.headObsolete && !this.headBeyond)
        {
          this.headDamageTypeStr += " has " + this.headOtherDamageDetails + ".";
        }
        else if (!this.headOtherDamage && this.headWaterDamage && !this.headFaultyControlGear && !this.headDayBurning && !this.headObsolete && !this.headBeyond)
        {
          this.headDamageTypeStr += " has water damage.";
        }
        else if (!this.headOtherDamage && !this.headWaterDamage && this.headFaultyControlGear && !this.headDayBurning && !this.headObsolete && !this.headBeyond)
        {
          this.headDamageTypeStr += " has a faulty control gear.";
        }
        else if (!this.headOtherDamage && !this.headWaterDamage && !this.headFaultyControlGear && this.headDayBurning && !this.headObsolete && !this.headBeyond)
        {
          this.headDamageTypeStr += " is day burning.";
        }
        else if (!this.headOtherDamage && !this.headWaterDamage && !this.headFaultyControlGear && !this.headDayBurning && !this.headObsolete && this.headBeyond)
        {
          this.headDamageTypeStr += " is beyond life.";
        }
        else if (!this.headOtherDamage && !this.headWaterDamage && !this.headFaultyControlGear && !this.headDayBurning && this.headObsolete && !this.headBeyond)
        {
          this.headDamageTypeStr += " is obsolete.";
        }
        else if (this.headOtherDamage && !this.headWaterDamage && this.headFaultyControlGear && !this.headDayBurning && !this.headObsolete && !this.headBeyond)
        {
          this.headDamageTypeStr += " has a faulty control gear and " + this.headOtherDamageDetails + ".";
        }
        else
        {
          if (this.headDayBurning)
          {
            if (this.headObsolete)
            {
              if (this.headBeyond)
              {
                this.headDamageTypeStr += " is beyond life, obsolete and dayburning";
              }
              else
              {
                this.headDamageTypeStr += " is obsolete and dayburning";
              }
            }
            else
            {
              if (this.headBeyond)
              {
                this.headDamageTypeStr += " is beyond life and dayburning";
              }
              else
              {
                this.headDamageTypeStr += " is dayburning";
              }
            }
           
            if (this.headWaterDamage)
            {
              this.headDamageTypeStr += " with water damage";
            }
            else if (this.headFaultyControlGear && !this.headOtherDamage)
            {
              this.headDamageTypeStr += " and";
            }
          }
          else
          {
            if (this.headWaterDamage)
            {
              if (this.headObsolete)
              {
                if (this.headBeyond)
                {
                  this.headDamageTypeStr += " is beyond life, obsolete and has water damage";
                }
                else
                {
                  this.headDamageTypeStr += " is obsolete and has water damage";
                }
              }
              else
              {
                if (this.headBeyond)
                {
                  this.headDamageTypeStr += " is beyond life and has water damage";
                }
                else
                {
                  this.headDamageTypeStr += " has water damage";
                }
              }
            }
            else
            {
              if (this.headObsolete)
              {
                if (this.headBeyond)
                {
                  this.headDamageTypeStr += " is beyond life and obsolete";
                }
                else
                {
                  this.headDamageTypeStr += " is obsolete";
                }
              }
              else
              {
                if (this.headBeyond)
                {
                  this.headDamageTypeStr += " is beyond life";
                }
              }
            }
          }

          if (!this.headOtherDamage && !this.headFaultyControlGear)
          {
            this.headDamageTypeStr += ".";
          }

          if (this.headOtherDamage)
          {
            if (this.headFaultyControlGear)
            {
              if (this.headWaterDamage)
              {
                this.headDamageTypeStr += ", a faulty control gear and " + this.headOtherDamageDetails + ".";
              }
              else
              {
                this.headDamageTypeStr += " with a faulty control gear and " + this.headOtherDamageDetails + ".";
              }
            }
            else
            {
              this.headDamageTypeStr += ", and " + this.headOtherDamageDetails + ".";
            }
          }
          else
          {
            if (this.headFaultyControlGear)
            {
              if (this.headWaterDamage)
              {
                this.headDamageTypeStr += " and a faulty control gear.";
              }
              else
              {
                this.headDamageTypeStr += " has a faulty control gear.";
              }
            }
          }
        }
    }
    else
    {
      this.headDamageTypeStr = "";
      this.headRepairTypeStr = "";
      this.ledRepair = false;
      this.soxRepair = false;
      this.sonRepair = false;
      this.photoCellRepair = false;
    }

    this.headDamage =  this.headDamageTypeStr + this.headRepairTypeStr;
  }


  headRepairType(choice)
  {
    switch(choice)
    {
      case 'led':
        this.ledRepair = !this.ledRepair;
        this.soxRepair = false;
        this.sonRepair = false;
        break;

      case 'sox':
        this.soxRepair = !this.soxRepair;
        this.ledRepair = false;
        this.sonRepair = false;
        break;

      case 'son':
        this.sonRepair = !this.sonRepair;
        this.soxRepair = false;
        this.ledRepair = false;
        break;

      case 'photo':
        this.photoCellRepair = !this.photoCellRepair;
        break;
    }

    this.headRepairTypeStr = "";

    if (this.ledRepair)
    {
      if (this.photoCellRepair)
      {
        this.headRepairTypeStr += " The photocell was replaced and an led head was installed.";
      }
      else
      {
        this.headRepairTypeStr += " A led head was installed.";
      }
    }
    else if (this.soxRepair)
    {
      if (this.photoCellRepair)
      {
        this.headRepairTypeStr += " The photocell was replaced and an sox head was installed.";
      }
      else
      {
        this.headRepairTypeStr += " A sox head was installed.";
      }
    }
    else if (this.sonRepair)
    {
      if (this.photoCellRepair)
      {
        this.headRepairTypeStr += " The photocell was replaced and an son head was installed.";
      }
      else
      {
        this.headRepairTypeStr += " A son head was installed.";
      }
    }
    else
    {
      if (this.photoCellRepair)
      {
        this.headRepairTypeStr += " The photocell was replaced.";
      }
    }

    this.headDamage =  this.headDamageTypeStr + this.headRepairTypeStr;
  }

  
  closeQuickPopulate()
  {
    this.quickPopulate = false;

    if (this.headDamage != "" && this.colDamage != "")
    {
      this.newObservation.observationInfo = this.headDamage + " " + this.colDamage;
    }
    else if (this.headDamage != "")
    {
      this.newObservation.observationInfo = this.headDamage;
    }
    else if (this.colDamage != "")
    {
      this.newObservation.observationInfo = this.colDamage;
    }
  }
}